"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Filter_1 = __importDefault(require("./Filter"));
const react_1 = require("react");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const classnames_1 = __importDefault(require("classnames"));
// Registreringsmerke, Kategori, Type, Eier, Operator, Registreringsdato
let filterSelection = [
    "mark",
    "aircraftModelCategory",
    "mainOwner",
    "aircraftName",
    "operator",
    "registrationDate",
    //  "airworthinessCategory",
    //  "aircraftConstructionYear",
    //  "mtom",
    //  "operator",
];
const FilterGroupMobile = (props) => {
    const [filterState, setFilterState] = (0, react_1.useState)(undefined);
    const [showAllFilters, toggleAllFilters] = (0, react_1.useState)(false);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const [activeFiltersCount, setActiveFiltersCount] = (0, react_1.useState)(0);
    const filterGroupEl = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!filterState) {
            const filterData = {};
            props.filters.forEach((filter) => {
                var _a;
                let key = filter.name;
                filterData[key] = {
                    name: filter.name,
                    data: (_a = filter.data) !== null && _a !== void 0 ? _a : [],
                    type: filter.type,
                    label: props.labels[key],
                    value: undefined,
                    expanded: false,
                    active: false,
                };
            });
            setFilterState(filterData);
        }
    });
    const changeFilter = (operation, data) => {
        if (!filterState) {
            return;
        }
        let activeCount = 0;
        Object.keys(filterState).forEach((key) => {
            if (filterState[key].name === data.name) {
                filterState[key].value = data.value;
            }
            if (filterState[key].active) {
                activeCount++;
            }
            if (operation === "expand") {
                filterState[key].expanded = filterState[key].name === data.name ? data.expanded : false;
            }
        });
        setActiveFiltersCount(activeCount);
        props.submit(filterState);
    };
    const resetFilters = () => {
        if (!filterState) {
            return;
        }
        const newState = (0, lodash_clonedeep_1.default)(filterState);
        Object.keys(newState).forEach((key) => {
            let filter = newState[key];
            filter.value = undefined;
            filter.active = false;
            filter.expanded = false;
        });
        setFilterState(newState);
        props.submit(newState);
        setActiveFiltersCount(0);
    };
    const scrollUp = () => {
        var _a;
        (_a = filterGroupEl.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            top: 0,
            behavior: "auto",
        });
    };
    let filterKeys = filterState ? Object.keys(filterState) : [];
    if (!showAllFilters)
        filterKeys = filterSelection;
    else {
        // reorder keys so it starts with values of filterSelection
        let keysEdit = [];
        filterSelection.forEach((s) => keysEdit.push(s));
        filterKeys.forEach((s) => {
            if (keysEdit.indexOf(s) < 0)
                keysEdit.push(s);
        });
        filterKeys = keysEdit;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("m-filter-container-mobile", {
            expanded: expanded,
        }), children: [(0, jsx_runtime_1.jsxs)("button", { className: "button toggle-filter", onClick: (ev) => {
                    ev.preventDefault();
                    setExpanded(!expanded);
                }, children: [(0, jsx_runtime_1.jsx)("img", { src: "/Resources/icons/icon_filter.svg", width: "20", alt: "", "aria-hidden": "true" }), (0, jsx_runtime_1.jsx)("div", { className: "m-filter-label", children: props.label })] }), expanded && ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("m-filter-body-filter", { expanded: expanded }), children: [(0, jsx_runtime_1.jsxs)("div", { className: "title-and-close", children: ["Filter", (0, jsx_runtime_1.jsxs)("a", { className: "a-close", href: "#", onClick: (ev) => {
                                    ev.preventDefault();
                                    setExpanded(!expanded);
                                }, children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {})] })] }), (0, jsx_runtime_1.jsx)("div", { className: "button-container", children: (0, jsx_runtime_1.jsxs)("button", { className: "remove-filters-button", onClick: resetFilters, children: ["Fjern (", activeFiltersCount, ")"] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "m-filter-group", ref: filterGroupEl, children: [filterState &&
                                filterKeys.map((key, i) => {
                                    return ((showAllFilters || i < 6) && ((0, jsx_runtime_1.jsx)(Filter_1.default, { data: filterState[key], changeFilter: changeFilter }, i)));
                                }), (0, jsx_runtime_1.jsx)("div", { className: "m-filter-container toggle-filters", children: (0, jsx_runtime_1.jsxs)("button", { onClick: () => {
                                        toggleAllFilters(!showAllFilters);
                                    }, children: [(0, jsx_runtime_1.jsx)("img", { src: "/Resources/icons/icon_filter.svg", width: "22", alt: "", "aria-hidden": "true" }), showAllFilters ? "Skjul filter" : "Alle filtre"] }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "scroll-up", children: (0, jsx_runtime_1.jsx)("a", { onClick: scrollUp, children: "Til toppen" }) }), (0, jsx_runtime_1.jsx)("div", { className: "show-results-button", children: (0, jsx_runtime_1.jsx)("div", { className: "close-button", children: (0, jsx_runtime_1.jsxs)("a", { href: "#", onClick: (ev) => {
                                    ev.preventDefault();
                                    setExpanded(!expanded);
                                }, children: ["Vis resultater (", props.totalItems, ")"] }) }) })] }))] }));
};
exports.default = FilterGroupMobile;
